
import { defineComponent, onMounted, ref, computed } from "vue";
import { useStore } from "vuex";

import { themeName, demo } from "@/core/helpers/documentation";
// import Callbacks from "@/views/admin/Callbacks.vue";
import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "add_alert_subdomain",
  components: {
    // Callbacks,
  },
  setup() {
    const store = useStore();
    const subdomains = ref([]);
    const verifiLoading = ref(false);
    const ethocaLoading = ref(false);

    onMounted(() => {
      setTimeout(async () => {
        getCallbacks();
      }, 1000);
    });

    const getCallbacks = async () => {
      try {
        const { data } = await ApiService.get(
          `customers/accounts?companygroupid=${store.getters.currentUser.data.companygroupid}`
        );
        const callback_details = data.data[0];
        subdomains.value = JSON.parse(callback_details.callbacks);
      } catch (e) {
        subdomains.value = [];
      }
    };

    const getEthoca = computed(() => {
      const ethoca = subdomains.value.find((ele) => {
        const keys = Object.keys(ele);
        if (keys[0] === "ethoca") {
          return true;
        }

        return false;
      });

      return ethoca;
    });

    const getVerifi = computed(() => {
      const verifi = subdomains.value.find((ele) => {
        const keys = Object.keys(ele);
        if (keys[0] === "verifi") {
          return true;
        }

        return false;
      });

      return verifi;
    });

    const addEthoca = async () => {
      ethocaLoading.value = true;
      try {
        await ApiService.post(
          `ethoca?action=alert_subdomain&customer_id=${store.getters.currentUser.data.customer_id}&companygroupid=${store.getters.currentUser.data.companygroupid}`,
          {}
        );
        await getCallbacks();
      } catch (e) {
        console.log(e);
      }
      ethocaLoading.value = false;
    };

    const addVerifi = async () => {
      verifiLoading.value = true;
      try {
        await ApiService.post(
          `verifi?action=alert_subdomain&customer_id=${store.getters.currentUser.data.customer_id}&companygroupid=${store.getters.currentUser.data.companygroupid}`,
          {}
        );
        await getCallbacks();
      } catch (e) {
        console.log(e);
      }
      verifiLoading.value = false;
    };

    return {
      themeName,
      demo,
      getEthoca,
      getVerifi,
      ethocaLoading,
      verifiLoading,
      addEthoca,
      addVerifi,
    };
  },
});
